module.exports = __webpack_public_path__ + "img/20200512_162645.411c2b55.jpg";